import { FixaTextArea } from "@coworker/apprestructured/src/shared/wrappers/FixaTextArea/FixaTextArea";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ImageIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ImageIconPath";
import { useTranslation } from "@coworker/locales";
import styles from "./AddComment.module.css";
import { AddImagesModal } from "../AddImagesModal/AddImagesModal";
import { useCallback, useState } from "react";

type AddCommentProps = {
  text: string;
  images: File[];
  disableAllInputs: boolean;
  disableAddButton: boolean;
  onTextChange: (text: string) => void;
  onImagesChange: (images: File[]) => void;
  onAddClick: () => void;
};

export const AddComment = ({
  text,
  images,
  disableAllInputs,
  disableAddButton,
  onTextChange,
  onImagesChange,
  onAddClick,
}: AddCommentProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<File[]>([]);

  const { t } = useTranslation();

  const handleAddImagesButtonClick = useCallback(() => {
    setModalImages(images);
    setIsModalOpen(true);
  }, [images]);

  const handleAddImagesModalConfirmClick = useCallback(() => {
    onImagesChange(modalImages);
  }, [modalImages, onImagesChange]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <div className={styles["addComment"]}>
      <FixaTextArea
        value={text}
        disabled={disableAllInputs}
        label={t("addCommentString")}
        onChange={(e) => onTextChange(e.target.value)}
      />
      <div className={styles["buttonWrapper"]}>
        <FixaButton
          size="xsmall"
          text={
            images.length > 0
              ? `${t("addImagesString")} (${images.length})`
              : t("addImagesString")
          }
          type="secondary"
          disabled={disableAllInputs}
          ssrIcon={ImageIconPath}
          onClick={handleAddImagesButtonClick}
        />
        <FixaButton
          size="xsmall"
          text={t("addString")}
          type="emphasised"
          disabled={
            disableAllInputs ||
            disableAddButton ||
            (!text && images.length === 0)
          }
          onClick={onAddClick}
        />
      </div>
      <AddImagesModal
        isOpen={isModalOpen}
        images={modalImages}
        onImagesChange={setModalImages}
        onClose={handleCloseModal}
        onConfirmClick={handleAddImagesModalConfirmClick}
      />
    </div>
  );
};
